module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAABHElEQVRYhe3Wv0oDQRDH8U/E1KYRLNRC30Ar8SFEtPF1VEyhVnmN1IIg6AvYBPQVJAlqIYomSiwy4ZagXfZQuB8Ms3+G/c7N3u4dlSrl0TZuMMQb2lgrC76PAUZ4wUe0+1gvAz4M4BnqaOAixtplwXtYTOYaeMcrarnh/fCdJIm68XYMMJcT3gxoZyqJ8+hf54ZPlCbRCz/AVhnwNInJdgwjfmbaUxy1019ijmP+EwcVvIJX8H8HTy+Z1i8xTZkuGejG4iM8YrdM+HIs/oSraH8lSWSFw04ALo2/3UeKSrRyw+EwICfRrykqMXP4/A9jG+EXIonNMIq3Peuv1YPiaVPrylD26QqsYgnPuMdtYnezhv+kBlbKAFX6M/oGnuuQx6252wsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/icons8-edit-32.png
// module id = vDOv
// module chunks = 1